import { Component, Input, OnInit, Output } from "@angular/core";

import { ItemService } from "src/app/_services/item.service";
import { PictureService } from "src/app/_services/picture.service";
import { ItemWithRelations } from "src/app/api/models";

@Component({
    selector: "art-item-preview-children",
    templateUrl: "./children.component.html",
    styleUrls: ["./children.component.scss"],
    standalone: false
})
export class ItemPreviewChildrenComponent implements OnInit {
  @Input() children: ItemWithRelations[];
  @Input() prepareItemQuickDialog: (id: string) => void;
  @Input() goToItemDetail: (id: string) => void;

  constructor(
    public _pictureService: PictureService,
    public _itemService: ItemService
  ) {}

  ngOnInit(): void {
    this.children.sort((a, b) => {
      return a.parentOrder - b.parentOrder;
    });
  }
}
